import { getEnv } from '@/composables/useEnv'
import { IFeatureFlags } from '@lifk/types'
import { computed, inject, Ref } from 'vue'

/** Reads the flags straight from the environment, for code outside the component tree such as router guards. */
export const getFeatureFlags = (): IFeatureFlags => ({
  comments: true,
  settings: getEnv('VITE_APP_SETTINGS') === 'true',
  stories: getEnv('VITE_APP_STORIES') === 'true'
})

// Inside components, prefer the provided flags so tests and stories can override them.
const useFeatureFlags = () => {
  const featureFlags = inject<Ref<IFeatureFlags> | undefined>(
    'featureFlags',
    undefined
  )

  const isEnabled = (flag: keyof IFeatureFlags) =>
    computed(() => featureFlags?.value[flag] ?? getFeatureFlags()[flag])

  return { featureFlags, isEnabled }
}

export default useFeatureFlags
